export default __webpack_public_path__ + "static/media/bigway.b9caa28b.mp4";